import { OrderItem, ItemStatus } from "../../types/items";
import { isEqual } from "lodash";

export const groupById = (items: OrderItem[]) => {
    // crear lista vacia
    const platos: (OrderItem & { index: number })[] = []


    // iteramos por cada plato
    items.forEach((i) => {
        // verificamos is el plato existe en la lista vacía
        const platosDuplicados = platos.filter((p) => p.id === i.id);
        
        // si existe 
        if (platosDuplicados.length) {
            // comparamos sus configuraciones con cada duplicado usando filter
            const configDuplicada = platosDuplicados.find((pd) => isEqual(pd.settings, i.settings));

            // si concuerda con alguno, 
            if (configDuplicada) {
                // encuentra el indice y aumenta la cantidad del encontrado
                const nuevoPlato = {...platos[configDuplicada.index]};
                nuevoPlato.quantity = nuevoPlato.quantity + 1;
                // reemplaza el plato
                platos.splice(configDuplicada.index, 1, nuevoPlato);
            } else {
                // si no, agregamos
                const index = platos.length;
                platos.push({...i, quantity: 1, index })
            }
        } else {
            // si no, agregamos
            const index = platos.length;
            platos.push({...i, quantity: 1, index })
        }
    })

    return platos;
}

export const groupByStatus = (items: OrderItem[]) => {
    const groupedItems = items.reduce((acc, curr) => ({
        ...acc,
        [curr.status]: [...(acc[curr.status] ?? []), curr]
    }), {} as Partial<Record<OrderItem['status'], OrderItem[]>>);

    return groupedItems;
}

export const groupOrderItemsByNameAndStatus = (items: OrderItem[], status: ItemStatus) => {
    const groupedItems: Record<string, OrderItem> = {};

    items.forEach((item) => {
        if (item.status === status) {
            const isAdded = !!groupedItems[item.id];

            if (isAdded) {
                const newItem = {
                    ...groupedItems[item.id],
                    quantity: Number(groupedItems[item.id]?.quantity ?? 1) + 1
                };

                groupedItems[item.id] = newItem;
            } else {
                groupedItems[item.id] = {
                    ...item,
                    quantity: 1
                };
            }
        }
    })
    return Object.values(groupedItems);
}
